module.exports = __webpack_public_path__ + "static/media/phone.480dadbb.svg";